import {Switch, withStyles} from "@material-ui/core";

export const TwoWaySwitch = withStyles(theme => ({
    track: {
        backgroundColor: theme.palette.primary.main,
        opacity: .5,
    },
    thumb: {
        backgroundColor: theme.palette.primary.main,
    },
}))(Switch);
